import { useContext } from 'react';
import RecordingContext from './RecordingContext';
import { usePreventRecordingAbandon } from '../../hooks/usePreventRecordingAbandon';

export default function RecordingAbandonGuard() {
  const { hasActiveSession, sessionUuid } = useContext(RecordingContext);
  usePreventRecordingAbandon(hasActiveSession, sessionUuid);
  return null;
}
